module.exports = __webpack_public_path__ + "static/media/Nutrition.a9c5a516.png";